import React, { useState } from "react";
import api from "../utils/api";

export default function ForgotPassword() {

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const res = await api.post("/auth/forgot-password", { email });

            setMessage(res.data.message);

        } catch (err) {
            setMessage("Something went wrong");
        }

        setLoading(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-lux-bg">

            <form onSubmit={handleSubmit} className="w-full max-w-md space-y-6">

                <h1 className="text-3xl font-display">Forgot Password</h1>

                <input
                    type="email"
                    placeholder="Enter your email"
                    className="input-lux w-full"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />

                <button className="btn-primary w-full">
                    {loading ? "Sending..." : "Send Reset Link"}
                </button>

                {message && (
                    <p className="text-green-600 text-sm">{message}</p>
                )}

            </form>

        </div>
    );
}